/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_QuestionInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_2_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the browser editor the newest GridCraft release?`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_2_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器编辑器一定是最新 GridCraft 版本吗？`)
};

/**
* | output |
* | --- |
* | "Is the browser editor the newest GridCraft release?" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_2_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_2_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_2_question(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_2_question(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_2_question as "gc.search_guides.gridcraft_online.sections.7.questions.2.question" }